import React, { useState, useEffect } from 'react';
import './WorkspaceAnalyticsTab.css';
import { Button, Drawer, Input, Table, Form, Select } from 'antd';
import { RiDatabase2Line } from 'react-icons/ri';
import ViewAccessRequest from './ViewAccessRequest/ViewAccessRequest';
import { useDispatch, useSelector } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { SettingsWorkspaceAnalyticsActionHandler } from '../../../../Redux/Actions/user/SettingsWorkspaceAnalyticsActions';
import { SettingsClientAnalyticsActionHandler } from '../../../../Redux/Actions/user/SettingsClientAnalyticsActions';
import { SettingsOwnerAnalyticsActionHandler } from '../../../../Redux/Actions/user/SettingsOwnerAnalyticsActions';
import { workspaces_Admin_Create_ActionHandler } from '../../../../Redux/Actions/user/WorkspaceAdminCreate';
import { EnterpriseClientsListActionHandler } from '../../../../Redux/Actions/user/EnterpriseClientsListAction';
import ViewAccessRequestToken from './ViewAccessRequest/ViewAccessRequestToken';
import { striped_managed_Client_list_ActionHandler } from '../../../../Redux/Actions/user/StripedManagedClientList';

const info6 = '/assets/info-6.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const vuesaxlinearusercirlceadd = '/assets/vuesaxlinearusercirlceadd.svg';
const { Option } = Select;
const WorkspaceAnalyticsTab = ({ user_client_id }) => {
    const SideClose = '/assets/ModalClose.svg';
    let dispatch = useDispatch();
    const [form] = Form.useForm();

    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data
    );

    const settingsowneranalyticsData = useSelector(
        (state) =>
            state.SettingsOwnerAnalyticsData?.settings_owner_analytics_data ||
            []
    );
    const enterpriseClientsListData = useSelector(
        (state) =>
            state?.EnterpriseClientsListData?.enterprise_clients_list_data
    );

    const settingsworkspaceanalyticsData = useSelector(
        (state) =>
            state?.SettingsWorkspaceAnalyticsData
                ?.settings_workspace_analytics_data
    );
    const settingsclientanalyticsData = useSelector(
        (state) =>
            state?.SettingsClientAnalyticsData?.settings_client_analytics_data
                ?.data || []
    );

    const StripedManaged_Clients_ListData = useSelector(
        (state) =>
            state.Striped_Managed_client_list_Data
                ?.striped_manged_client_list_data?.data
    );

    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(SettingsWorkspaceAnalyticsActionHandler('', '', page));
    };
    const [dataSource, setDataSource] = useState([]);
    const [enterpriseClientsData, setenterpriseClientsData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [stripedManagedClient, setstripedManagedClient] =
        useState('striped_managed');
    const [isDrawerVisible, setDrawerVisible] = useState(false);
    const [isAddCreditsOpen, setIsAddCreditsOpen] = useState(false);
    const [sortedInfo, setSortedInfo] = useState(null);
    const [isViewAccessRequestOpen, setIsViewAccessRequestOpen] =
        useState(false);
    const [isViewAccessRequestOpenToken, setIsViewAccessRequestOpenToken] =
        useState(false);
    const fetchData = async () => {
        try {
            dispatch(
                SettingsWorkspaceAnalyticsActionHandler('', '', currentPage)
            );
            dispatch(SettingsClientAnalyticsActionHandler());
            dispatch(EnterpriseClientsListActionHandler());
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleChangeClient = (value) => {
        setClientId(value);
        dispatch(SettingsOwnerAnalyticsActionHandler(value));
    };

    useEffect(() => {
        if (enterpriseClientsListData) {
            setenterpriseClientsData(enterpriseClientsListData);
        }
    }, [enterpriseClientsListData]);

    useEffect(() => {
        if (stripedManagedClient === 'striped_managed') {
            dispatch(striped_managed_Client_list_ActionHandler());
        }
    }, [stripedManagedClient]);

    const columns = [
        {
            title: 'workspace Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        { title: 'Admin', dataIndex: 'admin', key: 'admin' },
        { title: 'QAs Created', dataIndex: 'total_qa', key: 'total_qa' },
        {
            title: 'Credits Remaining',
            dataIndex: 'credits',
            key: 'credits',
            render: (text, record) => (
                <div>
                    <label>
                        {record.qa_credit_remaining}/{record.credits}
                    </label>
                    <label
                        className='workspaceanalyticsviewrequest'
                        onClick={ViewAccessRequestOverlayToken}>
                        View Request
                    </label>
                    {/* <label className="workspaceanalyticsaddcredits" onClick={AddCreditsOverlay}><RiDatabase2Line /><span>Add Credits</span></label> */}
                </div>
            ),
        },
        {
            title: 'Number of Users with Access',
            dataIndex: 'team_members',
            key: 'team_members',
            render: (text, record) => (
                <div>
                    <label>{record.team_members}</label>
                    <label
                        className='workspaceanalyticsviewrequest'
                        onClick={ViewAccessRequestOverlay}>
                        View Request
                    </label>
                </div>
            ),
        },
    ];

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearch = debounce((e) => {
        let value = e.target.value;
        let encodedValue = encodeURIComponent(value);
        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }
        if (!encodedValue.length) {
            dispatch(SettingsWorkspaceAnalyticsActionHandler('', '', '', ''));
        }
    }, 1000);

    const AddCreditsOverlay = () => {
        setIsAddCreditsOpen(!isAddCreditsOpen);
    };

    const ViewAccessRequestOverlay = () => {
        setIsViewAccessRequestOpen(!isViewAccessRequestOpen);
    };
    const ViewAccessRequestOverlayToken = () => {
        setIsViewAccessRequestOpenToken(!isViewAccessRequestOpenToken);
    };
    const OpenAddWorkspace = () => {
        setDrawerVisible(true);
    };
    const handleDrawerClose = () => {
        setDrawerVisible(false);
        setstripedManagedClient(null);
    };

    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                SettingsWorkspaceAnalyticsActionHandler(
                    searchValue,
                    '',
                    currentPage,
                    currentPage
                )
            );
        }
    }, [searchValue]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (
            settingsworkspaceanalyticsData?.data?.data &&
            settingsworkspaceanalyticsData?.data?.data?.length
        ) {
            setDataSource(settingsworkspaceanalyticsData?.data?.data);
        }
    }, [settingsworkspaceanalyticsData?.data?.data]);

    const onFinish = (values) => {
        let data = {
            workspace_name: values?.workspace_name,
            access_type: values?.access_type,
            owner_id: values?.owner_id,
            num_tokens: values?.credits,
            client_id: values?.client_id,
            ...(stripedManagedClient === 'striped_managed' && {
                workspace_type: true,
            }),
        };
        dispatch(workspaces_Admin_Create_ActionHandler(data));
        setTimeout(() => {
            form.resetFields();
            dispatch(
                SettingsWorkspaceAnalyticsActionHandler('', '', currentPage)
            );
            handleDrawerClose();
        }, 2000);
    };

    const handleEnterpriseClients = (value) => {
        setDataSource([]);
        dispatch(
            SettingsWorkspaceAnalyticsActionHandler(
                searchValue ? searchValue : '',
                '',
                currentPage,
                value
            )
        );
    };

    return (
        <>
            <div>
                <div className='workspaceanalytics-container'>
                    <div className='workspaceanalytics-main_1'>
                        <div className='relative search-container'>
                            <input
                                type='text'
                                placeholder='Search data here'
                                className='workspaceanalytics-search-from-logs'
                                onChange={(e) => handleSearch(e)}
                            />
                            <img
                                src={SearchIcon}
                                alt=''
                                className='search-icon upicon'
                            />
                        </div>
                        <div className='workspaceanalytics-main'>
                            <div>
                                <div className='workspaceanalytics-parent9'>
                                    {user_client_id === 1 && (
                                        <button
                                            onClick={OpenAddWorkspace}
                                            className='activeworkspaceanalytics'>
                                            Add Workspace
                                        </button>
                                    )}
                                    {/* <button className='activeworkspaceanalytics'>
                                        Buy More Credits
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {userProfileData?.client_id == 1 && (
                        <div className='workspaceanalytics-main_1'>
                            <div className='relative search-container'>
                                <Select
                                    placeholder='Select Client'
                                    className='uploadcomputer-select width-250'
                                    onChange={handleEnterpriseClients}>
                                    {enterpriseClientsListData &&
                                        enterpriseClientsListData?.length &&
                                        enterpriseClientsListData?.map(
                                            (list, index) => (
                                                <Option
                                                    key={index.toString()}
                                                    value={list.id}>
                                                    {list.name}
                                                </Option>
                                            )
                                        )}
                                </Select>
                            </div>
                        </div>
                    )}
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        size='middle'
                        className='mytable'
                        pagination={{
                            pageSize:
                                settingsworkspaceanalyticsData?.data?.per_page,
                            total: settingsworkspaceanalyticsData?.data?.total,
                            showSizeChanger: false,
                            onChange: handlePageChange,
                        }}
                        onChange={(pagination, filters, sorter) =>
                            setSortedInfo(sorter)
                        }
                    />
                </div>

                <Drawer
                    placement='right'
                    closable={false}
                    onClose={AddCreditsOverlay}
                    open={isAddCreditsOpen}
                    key='right'
                    width={'40%'}>
                    <img
                        className='workspaceanalytics-sideClose'
                        src={SideClose}
                        alt=''
                        onClick={AddCreditsOverlay}
                    />
                    <div className='side-modal-div'>
                        <h3>Credits Request</h3>
                    </div>
                    <div className='workspaceanalytics-input'>
                        <div className='workspaceanalytics-1'>
                            <label>
                                User: <b>George Clark</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Requested Credits: <b>200</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Workspace: <b>Marketing</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Date of Request: <b>16th Oct 2023</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmt-20'>
                            <hr />
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmb-20'>
                            <label>
                                Remaining Credits in Workspace: <b>100</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Text Field for Note (Optional)
                                <div className='tooltip'>
                                    <img src={info6} alt='info6' />
                                    <span className='tooltiptext'>
                                        Use this optional note to explain your
                                        decision when approving or declining the
                                        request.
                                    </span>
                                </div>
                            </label>
                            <Input />
                        </div>
                        <div className='workspaceanalytics-3'>
                            <label>Credits:</label>
                            <Input placeholder='50' />
                            <Button className='workspaceanalytics-buy-more-credits'>
                                Buy more Credits
                            </Button>
                            <Button className='workspaceanalytics-decline'>
                                Decline
                            </Button>
                        </div>
                    </div>
                </Drawer>
                {isViewAccessRequestOpen ? (
                    <ViewAccessRequest
                        isViewAccessRequestOpen={isViewAccessRequestOpen}
                        ViewAccessRequestOverlay={ViewAccessRequestOverlay}
                    />
                ) : null}
                {isViewAccessRequestOpenToken ? (
                    <ViewAccessRequestToken
                        isViewAccessRequestOpenToken={
                            isViewAccessRequestOpenToken
                        }
                        ViewAccessRequestOverlayToken={
                            ViewAccessRequestOverlayToken
                        }
                    />
                ) : null}
                <Drawer
                    placement='right'
                    closable={false}
                    onClose={ViewAccessRequest}
                    open={isViewAccessRequestOpen}
                    key='right'
                    width={'40%'}>
                    <img
                        className='workspaceanalytics-sideClose'
                        src={SideClose}
                        alt=''
                        onClick={ViewAccessRequest}
                    />
                    <div className='side-modal-div'>
                        <h3>Credits Request</h3>
                    </div>
                    <div className='workspaceanalytics-input'>
                        <div className='workspaceanalytics-1'>
                            <label>
                                User: <b>George Clark</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Requested Credits: <b>200</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Workspace: <b>Marketing</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Date of Request: <b>16th Oct 2023</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmt-20'>
                            <hr />
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmb-20'>
                            <label>
                                Remaining Credits in Workspace: <b>100</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Text Field for Note (Optional)
                                <div className='tooltip'>
                                    <img src={info6} alt='info6' />
                                    <span className='tooltiptext'>
                                        Use this optional note to explain your
                                        decision when approving or declining the
                                        request.
                                    </span>
                                </div>
                            </label>
                            <Input />
                        </div>
                        <div className='workspaceanalytics-3'>
                            <label>Credits:</label>
                            <Input placeholder='50' />
                            <Button className='workspaceanalytics-buy-more-credits'>
                                Buy more Credits
                            </Button>
                            <Button className='workspaceanalytics-decline'>
                                Decline
                            </Button>
                        </div>
                    </div>
                </Drawer>

                <Drawer
                    title='Add Workspace'
                    placement='right'
                    closable={true}
                    onClose={handleDrawerClose}
                    visible={isDrawerVisible}
                    width={500}>
                    {/* Add your form for editing here */}
                    <Form
                        form={form}
                        initialValues={{
                            client_type: 'striped_managed',
                            client_id: '',
                            owner_id: '',
                            access_type: '',
                            num_tokens: '',
                            workspace_name: '',
                        }}
                        onFinish={onFinish}>
                        <div className='new-btn'>
                            <h2>Add Workspace</h2>
                            <Button
                                className='close-btn'
                                type='text'
                                placement='right'
                                shape='circle'
                                icon={<CloseOutlined />}
                                size='large'
                                onClick={handleDrawerClose}
                            />
                        </div>

                        <div className='faq-input'>
                            <label>Select client type</label>
                            <Form.Item
                                name='client_type'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a Client!',
                                    },
                                ]}>
                                <Select
                                    showSearch
                                    placeholder='QuickAction'
                                    optionFilterProp='children'
                                    name='client_type'
                                    onChange={(value) => {
                                        setstripedManagedClient(value);
                                        form.setFieldsValue({ client_id: '' });
                                    }}
                                    defaultValue='striped_managed'>
                                    <Option value='striped_managed'>
                                        Striped Managed
                                    </Option>
                                    <Option value='enterprise_managed'>
                                        Enterprise{' '}
                                    </Option>
                                </Select>
                            </Form.Item>
                        </div>

                        <div className='faq-input'>
                            <label>Select name of client</label>
                            <Form.Item
                                name='client_id'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a Client!',
                                    },
                                ]}>
                                <Select
                                    showSearch
                                    placeholder='QuickAction'
                                    optionFilterProp='children'
                                    name='client_id'
                                    onChange={handleChangeClient}>
                                    {stripedManagedClient === 'striped_managed'
                                        ? StripedManaged_Clients_ListData?.map(
                                              (data) => (
                                                  <Option
                                                      key={data.id}
                                                      value={data.id}>
                                                      {data.name}
                                                  </Option>
                                              )
                                          )
                                        : enterpriseClientsData?.map((data) => (
                                              <Option
                                                  key={data.id}
                                                  value={data.id}>
                                                  {data.name}
                                              </Option>
                                          ))}
                                </Select>
                            </Form.Item>
                        </div>

                        <div className=''>
                            <label>Workspace name</label>
                            <Form.Item
                                name='workspace_name'
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please select a Workspace Name!',
                                    },
                                ]}>
                                <Input placeholder='Workspace name goes here' />
                            </Form.Item>
                        </div>
                        <div className=''>
                            <label>Credits</label>
                            <Form.Item
                                name='credits'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter Credits Token!',
                                    },
                                    {
                                        pattern: new RegExp(/^[0-9]+$/),
                                        message: 'Please enter a valid number!',
                                    },
                                ]}>
                                <Input
                                    placeholder='Credits Token'
                                    autoComplete='off'
                                />
                            </Form.Item>
                        </div>
                        <div className=''>
                            <label>Owner name</label>
                            <Form.Item
                                name='owner_id'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a Owner Name!',
                                    },
                                ]}>
                                <Select
                                    showSearch
                                    placeholder='Select'
                                    optionFilterProp='children'
                                    name='owner_id'>
                                    {settingsowneranalyticsData.map((data) => (
                                        <Option key={data.id} value={data.id}>
                                            {data.first_name} {data.last_name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className='mt-3 faq-input'>
                            <label>Access Type</label>
                            <Form.Item
                                name='access_type'
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please select any one Access Type',
                                    },
                                ]}>
                                <div className='access-workspaces'>
                                    <div className='access-container'>
                                        <div className='access-inner1'>
                                            <input
                                                type='radio'
                                                name='access_type'
                                                id='radioHidden'
                                                value='HIDDEN'
                                            />
                                            <p>Hidden </p>
                                        </div>
                                    </div>
                                    <div className='access-container'>
                                        <div className='access-inner1'>
                                            <input
                                                type='radio'
                                                name='access_type'
                                                id='radioRestricted'
                                                value='RESTRICTED'
                                            />
                                            <p>Restricted </p>
                                        </div>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>
                        <div className='upload'>
                            <button className='upload-button' type='submit'>
                                Add Workspace
                            </button>
                        </div>
                    </Form>
                </Drawer>
            </div>
        </>
    );
};
export default WorkspaceAnalyticsTab;
